import gql from "graphql-tag";

export default gql`
  mutation DeleteSite($id: ID!) {
    deleteSite(id: $id) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutations/DeleteSite.ts